module.exports = __webpack_public_path__ + "static/media/Logo.6710fe72.svg";